var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3701 5.08911C14.0874 5.23762 13.8369 5.57484 13.8369 6.098V7.80727C13.8369 8.35956 13.4237 8.80727 12.9139 8.80727H10.0708C6.27473 8.80727 2.93834 12.4298 2.77547 17.1329C4.60138 15.2065 6.9824 14.1002 9.5631 14.1002H12.9139C13.4237 14.1002 13.8369 14.5479 13.8369 15.1002V17.7211C13.8369 18.2442 14.0874 18.5814 14.3701 18.73C14.6527 18.8784 14.97 18.849 15.2254 18.5886C15.2255 18.5885 15.2253 18.5887 15.2254 18.5886L20.8934 12.7956C21.3713 12.2437 21.3045 11.4281 20.9247 11.0551L20.9112 11.0416L15.2256 5.23067C15.2255 5.23053 15.2258 5.23081 15.2256 5.23067C14.9703 4.97043 14.6526 4.94067 14.3701 5.08911ZM13.5646 3.28951C14.4749 2.8113 15.6299 2.89579 16.4913 3.77469L22.172 9.58064C23.4057 10.8009 23.3391 12.9308 22.2088 14.1994C22.1988 14.2106 22.1885 14.2215 22.1781 14.2322L16.4919 20.0438C15.6305 20.9227 14.4749 21.0078 13.5646 20.5295C12.6542 20.0513 11.9908 19.0211 11.9908 17.7211V16.1002H9.5631C6.76412 16.1002 4.20786 17.716 2.63498 20.5195C2.41999 20.9027 1.99582 21.084 1.59723 20.963C1.19864 20.8421 0.923096 20.4485 0.923096 20.0001V17.4932C0.923096 11.6588 5.02783 6.80727 10.0708 6.80727H11.9908V6.098C11.9908 4.79794 12.6542 3.76773 13.5646 3.28951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnroll);
export default __webpack_public_path__ + "static/media/enroll.0337e04f96a4d7b8477c776f237102e7.svg";
export { ForwardRef as ReactComponent };